module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-Bold.15798dcb.eot";